import { render, staticRenderFns } from "./files-history.vue?vue&type=template&id=27ec2ce4&scoped=true"
import script from "./files-history.vue?vue&type=script&lang=js"
export * from "./files-history.vue?vue&type=script&lang=js"
import style0 from "./files-history.vue?vue&type=style&index=0&id=27ec2ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ec2ce4",
  null
  
)

export default component.exports